"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import React from 'react';
import Main from './Main';
import LoginPage from './Login/LoginPage';
import D5Snackbars from './Snackbar/D5Snackbars';
import ApplicationStore from "Stores/ApplicationStore";
import { lightTheme, blueTheme } from "../theme";
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { System } from "Constants/objects";
var style = {
  height: '100%'
};

var Application =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Application, _React$Component);

  function Application(props) {
    var _this;

    _classCallCheck(this, Application);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Application).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = ApplicationStore.getList();
    ApplicationStore.setFavicon();
    ApplicationStore.setDocumentTitle();
    return _this;
  }

  _createClass(Application, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(ApplicationStore.getList());
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      ApplicationStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      ApplicationStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "themeFactory",
    value: function themeFactory() {
      var outTheme = {};
      var theme = this.state.theme;

      switch (theme) {
        case System.THEME.BLUE:
          outTheme = blueTheme;
          break;

        default:
          outTheme = lightTheme;
      }

      return outTheme;
    }
  }, {
    key: "drawMain",
    value: function drawMain() {
      var _this$state = this.state,
          initialized = _this$state.initialized,
          route = _this$state.route,
          drawerWidth = _this$state.drawerWidth,
          drawerOpen = _this$state.drawerOpen,
          drawerAnchor = _this$state.drawerAnchor;
      if (!initialized) return null;

      if (route === 'login' || document.location.hash === '#login') {
        return React.createElement(LoginPage, null);
      }

      return React.createElement(Main, {
        drawerWidth: drawerWidth,
        drawerOpen: drawerOpen,
        drawerAnchor: drawerAnchor
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(MuiThemeProvider, {
        theme: this.themeFactory()
      }, React.createElement(CssBaseline, null), this.drawMain(), React.createElement(D5Snackbars, null));
    }
  }]);

  return Application;
}(React.Component);

export { Application as default };